import { Icon } from '@chakra-ui/react'
import { BsCheckSquare, BsSquare } from 'react-icons/bs'

export const SquareCheckboxIcon = props => {
	const {
		isIndeterminate,
		isChecked,
		checkedProps,
		unCheckedProps,
		iconProps,
	} = props

	return (
		<>
			{isChecked ? (
				<Icon
					as={BsCheckSquare}
					color='brand.700'
					{...iconProps}
					{...checkedProps}
				/>
			) : (
				<Icon
					as={BsSquare}
					color='brand.700'
					{...iconProps}
					{...unCheckedProps}
				/>
			)}
		</>
	)
}
